import { useSyncExternalStore } from 'react';
import { sottoscriviSessioneAltrove, wasEvictedByNewSession } from '../services/socket';

/**
 * «Questo account si e' collegato da un altro dispositivo, e il server ha
 * chiuso la connessione qui.»
 *
 * Il fermo vive nel servizio socket (`newSessionEvicted`), che lo alza al
 * `force-disconnect: 'new-session'` e lo abbassa al logout o a «Usa qui».
 * `useSyncExternalStore` per leggerlo gia' al primo render: un componente che
 * monta dopo lo sfratto deve vedere l'avviso subito, non al cambio successivo.
 */
function leggiSulServer(): boolean {
  return false;
}

export function useSessioneAltrove(): boolean {
  return useSyncExternalStore(sottoscriviSessioneAltrove, wasEvictedByNewSession, leggiSulServer);
}
